import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { NavBarBadge, NavIcon } from "./components";
import CustomLink from "./CustomLink";

import userIcon from "../../../images/login-signup-icon.svg";
import { logout } from "../../../actions";

class Login extends React.Component {
  componentDidMount() {
   /* window.fbAsyncInit = function() {
      window.FB.init({
        appId: "309421312498803",
        cookie: true,
        xfbml: true,
        version: "v2.11"
      });

      window.FB.Event.subscribe("auth.statusChange", response => {
        if (response.authResponse) {
          this.handleLogin(response);
        } else {
          this.handleLogout();
        }
      });
    }.bind(this);

    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");*/
  }

  handleLogout = () => {
    /*window.FB.getLoginStatus(function(response) {
      if (response.status === "connected") {
        // the user is logged in and has authenticated your
        // app, and response.authResponse supplies
        // the user's ID, a valid access token, a signed
        // request, and the time the access token
        // and signed request each expire
        var uid = response.authResponse.userID;
        //var accessToken = response.authResponse.accessToken;

        window.FB.api("/" + uid + "/permissions", "delete", function(response) {});
      } else if (response.status === "not_authorized") {
        // the user is logged in to Facebook,
        // but has not authenticated your app
      } else {
        // the user isn't logged in to Facebook.
      }
    });*/
    this.props.logout();
  };

  handleLogin = response => {
    console.log(response);
  };
  render() {
    const { logged, name, wishCount, unpaid } = this.props;
    return (
      <Container>
        {logged ? (
          <span
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center"
            }}
          >
            <NavIcon icon={userIcon} />
            <span>{name}</span>
          </span>
        ) : (
          <CustomLink>
            <LinkContainer style={{ height: "100%" }}>
              <a
                style={{
                  height: "auto",
                  padding: 0,
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
                href={"/login?backref=" + window.location.href}
                className="custom-link"
              >
                <NavIcon icon={userIcon} />
                Login
              </a>
            </LinkContainer>
          </CustomLink>
        )}
        {logged && (
          <HoverList>
            <Item>
              <CustomLink>
                <a href="/my-profile" className="custom-link">
                  Profile
                </a>
              </CustomLink>
            </Item>
            <Item>
              <CustomLink>
                <a href="/my-profile/my-bookings" className="custom-link">
                  <LinkContainer>
                    My Bookings {unpaid > 0 && <NavBarBadge>{unpaid}</NavBarBadge>}
                  </LinkContainer>
                </a>
              </CustomLink>
            </Item>
            <Item>
              <CustomLink>
                <a href="/my-profile/enquiries" className="custom-link">
                  My Enquiries
                </a>
              </CustomLink>
            </Item>
            <Item>
              <CustomLink>
                <a href="/my-profile/wishlist" className="custom-link">
                  <LinkContainer>
                    Wishlist {wishCount > 0 && <NavBarBadge>{wishCount}</NavBarBadge>}
                  </LinkContainer>
                </a>
              </CustomLink>
            </Item>
            <Item>
              <CustomLink>
                <a href="#" className="custom-link" onClick={this.handleLogout}>
                  Logout
                </a>
              </CustomLink>
            </Item>
          </HoverList>
        )}
      </Container>
    );
  }
}
const HoverList = styled.ul`
  position: absolute;
  top: calc(100% + 2px);
  right: 0;
  z-index: 500;
  background-color: #fff;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;

  box-shadow: 5px 5px 15px 0 rgba(0, 0, 0, 0.2);

  display: none;

  padding: 0;
  margin: 0;
  list-style: none;
`;
const LinkContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const Container = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.5rem 0 0.2rem;
  border: 2px solid transparent;
  &:hover {
    border-bottom-color: #33cc99;
  }
  &:hover ${HoverList} {
    display: block;
  }
`;
export const Item = styled.li`
  width: 10rem;
  font-size: 1rem;
  font-weight: 400;
  color: #484848;
  cursor: pointer;
  &:hover {
    background-color: #f7f7f7;
  }
`;
const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(logout())
  };
};
export default connect(
  null,
  mapDispatchToProps
)(Login);
